"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVariableType = exports.ExpressionValidator = exports.ReferencedQuestionsVisitor = exports.PredicateSynthesizer = exports.PredicateConverter = exports.DereferenceTransformer = exports.ChoiceResolvingTransformer = exports.QuestionReferenceTransformer = exports.Predicate = exports.Choice = exports.Question = void 0;

var _nodes = require("./nodes");

var _visitors = require("./visitors");

var _expr = _interopRequireDefault(require("./expr"));

var _enums = require("./enums");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var _getVariableType = function getVariableType(question, rowId, columnId, choiceId) {
  var _question$display_opt, _question$answer_opti, _question$type;

  var expect1 = function expect1(type) {
    if ((typeof rowId === 'undefined' || rowId === null) && (typeof columnId === 'undefined' || columnId === null)) {
      return type;
    }

    return undefined;
  };

  var expect2 = function expect2(type) {
    if (typeof rowId !== 'undefined' && rowId !== null && (typeof columnId === 'undefined' || columnId === null)) {
      return type;
    }

    return undefined;
  };

  var expect3 = function expect3(type) {
    if (typeof rowId !== 'undefined' && rowId !== null && typeof columnId !== 'undefined' && columnId !== null) {
      return type;
    }

    return undefined;
  };

  if (((_question$display_opt = question.display_options) === null || _question$display_opt === void 0 ? void 0 : _question$display_opt.display_type) === 'slider') {
    return _enums.VariableType.Number;
  }

  if ((_question$answer_opti = question.answer_options) !== null && _question$answer_opti !== void 0 && _question$answer_opti.other) {
    var otherId = question.answer_options.other.id;

    if (rowId === otherId || columnId === otherId || choiceId === otherId) {
      return _enums.VariableType.String;
    }
  }

  switch ((_question$type = question.type) === null || _question$type === void 0 ? void 0 : _question$type.family) {
    case _enums.QuestionFamily.SingleChoice:
      return expect1(_enums.VariableType.Single);

    case _enums.QuestionFamily.MultipleChoice:
      return expect1(_enums.VariableType.Multi);

    case _enums.QuestionFamily.OpenEnded:
      {
        switch (question.type.subtype) {
          case _enums.QuestionSubtype.Single:
          case _enums.QuestionSubtype.Essay:
            return expect1(_enums.VariableType.String);

          case _enums.QuestionSubtype.Multi:
          case _enums.QuestionSubtype.Numerical:
            return expect2(_enums.VariableType.String);
        }

        break;
      }

    case _enums.QuestionFamily.Matrix:
      {
        switch (question.type.subtype) {
          case _enums.QuestionSubtype.Single:
          case _enums.QuestionSubtype.Rating:
          case _enums.QuestionSubtype.Ranking:
            return expect2(_enums.VariableType.Single);

          case _enums.QuestionSubtype.Multi:
            return expect2(_enums.VariableType.Multi);

          case _enums.QuestionSubtype.Menu:
            return expect3(_enums.VariableType.Single);
        }

        break;
      }

    case _enums.QuestionFamily.Demographic:
      {
        return expect2(_enums.VariableType.String);
      }
  }

  return undefined;
};

exports.getVariableType = _getVariableType;

var Question = /*#__PURE__*/function (_Expression) {
  _inherits(Question, _Expression);

  var _super = _createSuper(Question);

  function Question(id, row, column, choice) {
    var _this;

    _classCallCheck(this, Question);

    _this = _super.call(this);
    _this.id = id;
    _this.row = row;
    _this.column = column;
    _this.choice = choice;
    _this.display_options = void 0;
    _this.display_number = void 0;
    _this.type = void 0;
    _this.answer_options = void 0;
    return _this;
  }

  _createClass(Question, [{
    key: "toString",
    value: function toString() {
      var result = "$Q".concat(this.id);

      if (this.row != null) {
        result += "$R".concat(this.row);
      }

      if (this.column != null) {
        result += "$C".concat(this.column);
      }

      if (this.choice != null) {
        result += "$C".concat(this.choice);
      }

      return result;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var result = {
        type: 'question',
        id: this.id
      };

      if (this.row) {
        result.row = this.row;
      }

      if (this.column) {
        result.column = this.column;
      }

      if (this.choice) {
        result.choice = this.choice;
      }

      return result;
    }
  }, {
    key: "getPredicateId",
    value: function getPredicateId() {
      if (this.row != null && this.column != null) {
        return "".concat(this.id, ".").concat(this.row, ".").concat(this.column);
      }

      if (this.row != null) {
        return "".concat(this.id, ".").concat(this.row);
      }

      if (this.choice != null) {
        return "".concat(this.id, ".").concat(this.choice);
      }

      return this.id;
    }
  }, {
    key: "getVariableType",
    value: function getVariableType(survey) {
      var question = survey.getQuestion(this.id);

      if (!question) {
        return undefined;
      }

      return _getVariableType(question, this.row, this.column, this.choice);
    }
  }, {
    key: "getQuestionInfo",
    value: function getQuestionInfo(survey) {
      var question = survey.getQuestion(this.id);

      if (!question) {
        return undefined;
      }

      var info = {
        question: question
      };

      if (this.row) {
        if (question.answer_options) {
          var _question$answer_opti2, _question$answer_opti3;

          for (var i = 0; i < question.answer_options.rows.length; i += 1) {
            var _row = question.answer_options.rows[i];

            if (_row.id.toString() === this.row) {
              info.row = _row;
              break;
            }
          }

          if (this.row === ((_question$answer_opti2 = question.answer_options) === null || _question$answer_opti2 === void 0 ? void 0 : (_question$answer_opti3 = _question$answer_opti2.other) === null || _question$answer_opti3 === void 0 ? void 0 : _question$answer_opti3.id)) {
            info.row = question.answer_options.other;
          }

          if (!info.row) {
            throw new Error('Unknown row');
          }
        }
      }

      if (this.column) {
        var _question$answer_opti4;

        if ((_question$answer_opti4 = question.answer_options) !== null && _question$answer_opti4 !== void 0 && _question$answer_opti4.cols) {
          var _question$answer_opti5;

          for (var _i = 0; _i < question.answer_options.cols.length; _i += 1) {
            var _column = question.answer_options.cols[_i];

            if (_column.id === this.column) {
              info.column = _column;
              break;
            }
          }

          if (this.column === ((_question$answer_opti5 = question.answer_options.other) === null || _question$answer_opti5 === void 0 ? void 0 : _question$answer_opti5.id)) {
            info.column = question.answer_options.other;
          }

          if (!info.column) {
            throw new Error('Unknown column');
          }
        }
      }

      if (this.choice) {
        if (question.answer_options) {
          var _question$answer_opti6;

          for (var _i2 = 0; _i2 < question.answer_options.rows.length; _i2 += 1) {
            var _choice = question.answer_options.rows[_i2];

            if (_choice.id === this.choice) {
              info.choice = _choice;
              break;
            }
          }

          if (this.choice === ((_question$answer_opti6 = question.answer_options.other) === null || _question$answer_opti6 === void 0 ? void 0 : _question$answer_opti6.id)) {
            info.choice = question.answer_options.other;
          }

          if (!info.choice) {
            throw new Error('Unknown choice');
          }
        }
      }

      return info;
    }
  }, {
    key: "__eval__",
    value: function __eval__(ctx) {
      return ctx.getQuestionContext(this);
    }
  }], [{
    key: "create",
    value: function create(info) {
      if (info.id == null) {
        throw new Error("".concat(info));
      }

      return new Question(info.id, info.row, info.column, info.choice);
    }
  }]);

  return Question;
}(_nodes.Expression);

exports.Question = Question;
Question.attrs = ['id', 'row', 'column', 'choice'];

_nodes.Node.register('Question', Question);

var Choice = /*#__PURE__*/function (_Expression2) {
  _inherits(Choice, _Expression2);

  var _super2 = _createSuper(Choice);

  function Choice(question, id) {
    var _this2;

    var ident = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'row_id';

    _classCallCheck(this, Choice);

    _this2 = _super2.call(this);
    _this2.question = question;
    _this2.id = id;
    _this2.ident = ident;
    return _this2;
  }

  _createClass(Choice, [{
    key: "toString",
    value: function toString() {
      return "$C".concat(this.id);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: 'choice',
        question: this.question,
        id: this.id,
        ident: this.ident
      };
    }
  }, {
    key: "getChoiceInfo",
    value: function getChoiceInfo(survey) {
      var _question$answer_opti7, _question$answer_opti8, _question$answer_opti9, _question$answer_opti10, _question$answer_opti11, _question$answer_opti12, _question$answer_opti13, _question$answer_opti14;

      var question = survey.getQuestion(this.question);

      if (!question) {
        return undefined;
      }

      var columns = (_question$answer_opti7 = (_question$answer_opti8 = question.answer_options) === null || _question$answer_opti8 === void 0 ? void 0 : _question$answer_opti8.cols) !== null && _question$answer_opti7 !== void 0 ? _question$answer_opti7 : [];

      for (var i = 0; i < columns.length; i += 1) {
        var _column2$col_choices;

        var _column2 = columns[i];

        if (_column2.id === this.id) {
          return _column2;
        }

        var colChoices = (_column2$col_choices = _column2.col_choices) !== null && _column2$col_choices !== void 0 ? _column2$col_choices : [];

        for (var j = 0; j < colChoices.length; j += 1) {
          var colChoice = colChoices[j];

          if (colChoice.id === this.id) {
            return colChoice;
          }
        }
      }

      var choices = (_question$answer_opti9 = (_question$answer_opti10 = question.answer_options) === null || _question$answer_opti10 === void 0 ? void 0 : _question$answer_opti10.rows) !== null && _question$answer_opti9 !== void 0 ? _question$answer_opti9 : [];

      for (var _i3 = 0; _i3 < choices.length; _i3 += 1) {
        var _choice2 = choices[_i3];

        if (_choice2.id.toString() === this.id) {
          return _choice2;
        }
      }

      if (((_question$answer_opti11 = question.answer_options) === null || _question$answer_opti11 === void 0 ? void 0 : (_question$answer_opti12 = _question$answer_opti11.other) === null || _question$answer_opti12 === void 0 ? void 0 : _question$answer_opti12.id) === this.id && question.answer_options.other_type === 'answer_option') {
        return question.answer_options.other;
      }

      if (((_question$answer_opti13 = question.answer_options) === null || _question$answer_opti13 === void 0 ? void 0 : (_question$answer_opti14 = _question$answer_opti13.na_col) === null || _question$answer_opti14 === void 0 ? void 0 : _question$answer_opti14.id) === this.id) {
        return question.answer_options.na_col;
      }

      throw new Error('Unknown choice');
    }
  }, {
    key: "__eval__",
    value: function __eval__(ctx) {
      return ctx.getChoiceContext(this);
    }
  }], [{
    key: "create",
    value: function create(info) {
      if (!info.id || !info.question) {
        throw new Error("".concat(info));
      }

      return new Choice(info.question, info.id);
    }
  }]);

  return Choice;
}(_nodes.Expression);

exports.Choice = Choice;
Choice.attrs = ['question', 'id', 'ident'];

_nodes.Node.register('Choice', Choice);

var Predicate = /*#__PURE__*/function (_Expression3) {
  _inherits(Predicate, _Expression3);

  var _super3 = _createSuper(Predicate);

  function Predicate(variable, predicate, value) {
    var _this3;

    _classCallCheck(this, Predicate);

    _this3 = _super3.call(this);
    _this3.variable = variable;
    _this3.predicate = predicate;
    _this3.value = value;
    return _this3;
  }

  _createClass(Predicate, [{
    key: "isMeta",
    value: function isMeta() {
      return this.variable in Predicate.metas || /^contact\.custom/.test(this.variable) || /^custom\./.test(this.variable) || /^respondent\./.test(this.variable);
    }
  }, {
    key: "getQuestionId",
    value: function getQuestionId() {
      var ref = Predicate.variableRegex.exec(this.variable);
      return ref !== null ? ref[1] : undefined;
    }
  }, {
    key: "getVariableNode",
    value: function getVariableNode(survey) {
      var _question$answer_opti15, _question$type2;

      if (typeof _expr["default"] !== 'undefined' && _expr["default"] !== null && this.isMeta()) {
        return _expr["default"].parse(this.variable);
      }

      var match = Predicate.variableRegex.exec(this.variable);
      var questionId = (match === null || match === void 0 ? void 0 : match[1]) || '',
          rowId = (match === null || match === void 0 ? void 0 : match[3]) || null,
          columnId = (match === null || match === void 0 ? void 0 : match[5]) || null;
      var question = survey.getQuestion(questionId);

      if (question !== null && question !== void 0 && (_question$answer_opti15 = question.answer_options) !== null && _question$answer_opti15 !== void 0 && _question$answer_opti15.other && question.answer_options.other_type === 'comment') {
        if (rowId === question.answer_options.other.id) {
          return new Question(questionId, rowId);
        }
      }

      switch (question === null || question === void 0 ? void 0 : (_question$type2 = question.type) === null || _question$type2 === void 0 ? void 0 : _question$type2.family) {
        case _enums.QuestionFamily.SingleChoice:
        case _enums.QuestionFamily.MultipleChoice:
          return new Question(questionId, undefined, undefined, rowId);

        default:
          return new Question(questionId, rowId, columnId);
      }
    }
  }, {
    key: "getVariableType",
    value: function getVariableType(survey) {
      if (this.isMeta()) {
        return _enums.VariableType.String;
      }

      var match = Predicate.variableRegex.exec(this.variable);

      if (match == null) {
        return undefined;
      }

      var _ref = [match[1], match[3] || null, match[5] || null],
          questionId = _ref[0],
          rowId = _ref[1],
          columnId = _ref[2];
      var question = survey.getQuestion(questionId);

      if (question == null) {
        return undefined;
      }

      return _getVariableType(question, rowId, columnId);
    }
  }]);

  return Predicate;
}(_nodes.Expression);

exports.Predicate = Predicate;
Predicate.attrs = ['variable', 'predicate', 'value'];
Predicate.metas = {
  'contact.name': 'contact.name',
  'contact.email': 'contact.email',
  'contact.first_name': 'contact.first_name',
  'contact.last_name': 'contact.last_name',
  'contact.custom': 'contact.custom',
  'metadata.browser': 'metadata.browser',
  'metadata.ip': 'metadata.ip',
  'metadata.referrer': 'metadata.referrer'
};
Predicate.variableRegex = /^(\d+)(\.(\d+)(\.(\d+))?)?$/;

_nodes.Node.register('Predicate', Predicate);

var QuestionReferenceTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(QuestionReferenceTransformer, _Transformer);

  var _super4 = _createSuper(QuestionReferenceTransformer);

  function QuestionReferenceTransformer(mapping) {
    var _this4;

    _classCallCheck(this, QuestionReferenceTransformer);

    _this4 = _super4.call(this);
    _this4.mapping = mapping;
    _this4.questionMap = {};
    return _this4;
  }

  _createClass(QuestionReferenceTransformer, [{
    key: "transform",
    value: function transform(node) {
      this.questionMap = {};
      return this.visit(node);
    }
  }, {
    key: "visit_Attribute",
    value: function visit_Attribute(node) {
      var value = this.visit(node.value); // eslint-disable-next-line no-param-reassign

      node = new _nodes.Attribute(value, node.attr);

      if (/^alias$/i.exec(node.value.id)) {
        var _question = this.mapping[node.attr];

        if (!_question) {
          throw new Error("Could not find ".concat(node.attr, " in mapping"));
        }

        this.questionMap[_question.id] = _question;
        return new Question(_question.id);
      }

      if (!(value instanceof Question)) {
        return node;
      }

      var question = this.questionMap[value.id];
      var question_type;

      if (question.type != null) {
        question_type = question.type.family;
      }

      if (question_type === 'presentation') {
        return node;
      }

      var options = this.questionMap[value.id].answer_options;

      if (options.other && /^OTHER$/i.exec(node.attr)) {
        // other comment/choice/row
        if (options.other_type === 'comment' && !(value.choice != null || value.row != null || value.column != null)) {
          return new Question(value.id, options.other.id);
        }

        if (options.other_type === 'answer_option' && !(value.choice != null || value.row != null || value.column != null)) {
          return new Question(value.id, undefined, undefined, options.other.id);
        }

        if (options.other_type === 'comment_per_row' && value.row != null && value.column == null) {
          return new Question(value.id, value.row, options.other.id);
        }
      }

      var rmatch = /^R(\d+)$/i.exec(node.attr);
      var cmatch = /^C(\d+)$/i.exec(node.attr);

      if (!(rmatch || cmatch)) {
        return node;
      }

      if (rmatch && !(value.choice != null || value.row != null || value.column != null)) {
        // find row
        var _row2 = parseInt(rmatch[1], 10);

        var ref = options.rows[_row2 - 1];
        var rowId = ref != null ? ref.id : undefined;

        if (rowId == null) {
          return node;
        }

        return new Question(value.id, rowId);
      }

      if (cmatch && !(value.choice != null || value.row != null || value.column != null || options.cols != null)) {
        // find choice
        var _choice3 = parseInt(cmatch[1], 10);

        var ref1 = options.rows[_choice3 - 1];
        var choiceId = ref1 != null ? ref1.id : undefined;

        if (choiceId == null) {
          return node;
        }

        return new Question(value.id, undefined, undefined, choiceId);
      }

      if (cmatch && value.row != null && options.cols != null && value.column == null) {
        // find column
        var col = parseInt(cmatch[1], 10);
        var ref2 = options.cols[col - 1];
        var colId = ref2 != null ? ref2.id : undefined;

        if (colId == null) {
          return node;
        }

        return new Question(value.id, value.row, colId);
      }

      throw new Error("Could not find ".concat(node.attr, " in mapping"));
    }
  }, {
    key: "visit_Identifier",
    value: function visit_Identifier(node) {
      var match = /^Q(\d+)$/i.exec(node.id);

      if (!match) {
        return node;
      }

      var number = parseInt(match[1], 10);
      var question = this.mapping[number];

      if (question == null) {
        throw new Error("Could not find Q".concat(number, " in mapping"));
      }

      var result = new Question(question.id); // tag for finding row/column/choice IDs for attributes

      this.questionMap[question.id] = question;
      return result;
    }
  }]);

  return QuestionReferenceTransformer;
}(_visitors.Transformer);

exports.QuestionReferenceTransformer = QuestionReferenceTransformer;

var ChoiceResolvingTransformer = /*#__PURE__*/function (_Transformer2) {
  _inherits(ChoiceResolvingTransformer, _Transformer2);

  var _super5 = _createSuper(ChoiceResolvingTransformer);

  function ChoiceResolvingTransformer(survey) {
    var _this5;

    _classCallCheck(this, ChoiceResolvingTransformer);

    _this5 = _super5.call(this);
    _this5.survey = survey;
    _this5.tagged = false;
    return _this5;
  }

  _createClass(ChoiceResolvingTransformer, [{
    key: "transform",
    value: function transform(node) {
      this.tagged = false;
      this.visit(node);
      this.tagged = true;
      return this.visit(node, node.tag);
    }
  }, {
    key: "visit_Question",
    value: function visit_Question(node, tag) {
      if (!this.tagged) {
        if (node.column) {
          // eslint-disable-next-line no-param-reassign, no-multi-assign
          tag = node.tag = [node.id, node.column];
        } else {
          // eslint-disable-next-line no-param-reassign, no-multi-assign
          tag = node.tag = node.id;
        }

        return tag;
      }

      return node;
    }
  }, {
    key: "visit_Identifier",
    value: function visit_Identifier(node, tag) {
      var _question$answer_opti17, _question$type3, _question$answer_opti20;

      if (!this.tagged) {
        return undefined;
      }

      var id;
      var column;

      if (Array.isArray(tag)) {
        var _tag = _slicedToArray(tag, 2);

        id = _tag[0];
        column = _tag[1];
      } else {
        id = tag;
      }

      var question = this.survey.getQuestion(id);

      if (!(id != null && question)) {
        return node;
      }

      if (node.id.toLowerCase() === 'na') {
        var _question$answer_opti16;

        if ((_question$answer_opti16 = question.answer_options) !== null && _question$answer_opti16 !== void 0 && _question$answer_opti16.na_col) {
          return new Choice(question.id, question.answer_options.na_col.id);
        }
      }

      var match = /^C(\d+)$/i.exec(node.id);

      if (!match) {
        return node;
      }

      var choices = (_question$answer_opti17 = question.answer_options) === null || _question$answer_opti17 === void 0 ? void 0 : _question$answer_opti17.cols;

      if (choices == null) {
        var _question$answer_opti18;

        choices = (_question$answer_opti18 = question.answer_options) === null || _question$answer_opti18 === void 0 ? void 0 : _question$answer_opti18.rows;
      }

      if (choices == null) {
        choices = [];
      }

      if (column && ((_question$type3 = question.type) === null || _question$type3 === void 0 ? void 0 : _question$type3.family) === 'matrix' && question.type.subtype === 'menu') {
        var _question$answer_opti19;

        var ref = ((_question$answer_opti19 = question.answer_options) === null || _question$answer_opti19 === void 0 ? void 0 : _question$answer_opti19.cols) || [];

        for (var i = 0, len = ref.length; i < len; i += 1) {
          var col = ref[i];

          if (col.id === column) {
            choices = col.col_choices;
            break;
          }
        }
      }

      if (((_question$answer_opti20 = question.answer_options) === null || _question$answer_opti20 === void 0 ? void 0 : _question$answer_opti20.other_type) === 'answer_option') {
        choices = choices.concat([question.answer_options.other]);
      }

      var number = parseInt(match[1], 10);
      var choice = choices[number - 1];

      if (!choice) {
        throw new Error("Could not find C".concat(number, " in mapping"));
      }

      return new Choice(question.id, choice.id);
    }
  }, {
    key: "visit_Node",
    value: function visit_Node(node, tag) {
      var _this6 = this;

      if (!this.tagged) {
        var qtag;
        var conflict = false; // TODO:
        // eslint-disable-next-line consistent-return

        this.recurseChildren(node, function (child) {
          var ctag = _this6.visit(child);

          if (ctag != null && qtag != null && ctag !== qtag) {
            conflict = true;
          }

          if (ctag != null) {
            // eslint-disable-next-line no-return-assign
            return qtag = ctag;
          }
        });

        if (!conflict) {
          // eslint-disable-next-line no-param-reassign
          node.tag = qtag;
        }

        return qtag;
      }

      var changed = false;
      var params = this.recurseChildren(node, function (child) {
        var ref = child.tag;

        var rep = _this6.visit(child, ref != null ? ref : tag);

        if (rep !== child) {
          changed = true;
        }

        return rep;
      });

      if (!changed) {
        return node;
      }

      return this.buildNode(node.constructor, params);
    }
  }]);

  return ChoiceResolvingTransformer;
}(_visitors.Transformer);

exports.ChoiceResolvingTransformer = ChoiceResolvingTransformer;

var DereferenceTransformer = /*#__PURE__*/function (_Transformer3) {
  _inherits(DereferenceTransformer, _Transformer3);

  var _super6 = _createSuper(DereferenceTransformer);

  function DereferenceTransformer(survey) {
    var _this7;

    _classCallCheck(this, DereferenceTransformer);

    _this7 = _super6.call(this);
    _this7.survey = survey;
    _this7.choiceMap = {};
    return _this7;
  }

  _createClass(DereferenceTransformer, [{
    key: "transform",
    value: function transform(node) {
      this.choiceMap = {}; // transform question references, keeping a mapping
      // eslint-disable-next-line no-param-reassign

      node = this.visit(node); // transform choice references using mapping

      return this.visit(node, true);
    }
  }, {
    key: "visit_Question",
    value: function visit_Question(node, mapped) {
      var _this$survey$getQuest, _question$answer_opti21, _question$answer_opti23, _question$answer_opti24;

      var info = node.getQuestionInfo(this.survey);

      if (!info) {
        return node;
      }

      var question = info.question;
      var pos = (_this$survey$getQuest = this.survey.getQuestion(question.id)) === null || _this$survey$getQuest === void 0 ? void 0 : _this$survey$getQuest.display_number;
      var choices = (_question$answer_opti21 = question.answer_options) === null || _question$answer_opti21 === void 0 ? void 0 : _question$answer_opti21.cols;

      if (choices == null) {
        var _question$answer_opti22;

        choices = (_question$answer_opti22 = question.answer_options) === null || _question$answer_opti22 === void 0 ? void 0 : _question$answer_opti22.rows;
      }

      if (choices == null) {
        choices = [];
      }

      for (var i = 0; i < choices.length; i += 1) {
        var _choice4$col_choices;

        var _choice4 = choices[i];
        this.choiceMap[_choice4.id] = _choice4;
        this.choiceMap[_choice4.id].index = i;
        var colChoices = (_choice4$col_choices = _choice4.col_choices) !== null && _choice4$col_choices !== void 0 ? _choice4$col_choices : [];

        for (var j = 0; j < colChoices.length; j += 1) {
          var colChoice = colChoices[j];
          this.choiceMap[colChoice.id] = colChoice;
          this.choiceMap[colChoice.id].index = j;
        }
      }

      if ((_question$answer_opti23 = question.answer_options) !== null && _question$answer_opti23 !== void 0 && _question$answer_opti23.other) {
        this.choiceMap[question.answer_options.other.id] = {
          position: choices.length + 1,
          index: choices.length,
          text: question.answer_options.other.text
        };
      }

      if ((_question$answer_opti24 = question.answer_options) !== null && _question$answer_opti24 !== void 0 && _question$answer_opti24.na_col) {
        this.choiceMap[question.answer_options.na_col.id] = {
          is_na_col: true,
          text: question.answer_options.na_col.text
        };
      }

      var id = new _nodes.Identifier("Q".concat(pos));

      if ((info === null || info === void 0 ? void 0 : info.row) != null) {
        if (info.row.type === 'other') {
          id = new _nodes.Attribute(id, 'OTHER');
        } else {
          id = new _nodes.Attribute(id, "R".concat(info.row.position));
        }
      }

      if (info.column != null) {
        if (info.column.type === 'other') {
          id = new _nodes.Attribute(id, 'OTHER');
        } else {
          id = new _nodes.Attribute(id, "C".concat(info.column.position));
        }
      }

      if (info.choice != null) {
        if (info.choice.type === 'other') {
          id = new _nodes.Attribute(id, 'OTHER');
        } else {
          id = new _nodes.Attribute(id, "C".concat(info.choice.position));
        }
      }

      return id;
    }
  }, {
    key: "visit_Choice",
    value: function visit_Choice(node, mapped) {
      if (!mapped) {
        return node;
      }

      var info = this.choiceMap[node.id];

      if (info == null) {
        return node;
      }

      var id;

      if (info.is_na_col) {
        id = new _nodes.Identifier('NA');
      } else {
        id = new _nodes.Identifier("C".concat(info.index + 1));
      }

      return id;
    }
  }]);

  return DereferenceTransformer;
}(_visitors.Transformer);
/**
 * This transformer converts `Predicate` nodes into their equivalent
 * decomposition with regular expression nodes.
 */


exports.DereferenceTransformer = DereferenceTransformer;

var PredicateConverter = /*#__PURE__*/function (_Transformer4) {
  _inherits(PredicateConverter, _Transformer4);

  var _super7 = _createSuper(PredicateConverter);

  function PredicateConverter(survey) {
    var _this8;

    _classCallCheck(this, PredicateConverter);

    _this8 = _super7.call(this);
    _this8.survey = survey;
    return _this8;
  }

  _createClass(PredicateConverter, [{
    key: "visit_Predicate",
    value: function visit_Predicate(node) {
      var type = node.getVariableType(this.survey);
      var variable = node.getVariableNode(this.survey);

      if (!(variable instanceof _nodes.Node)) {
        return node;
      }

      var value = node.value,
          predicate = node.predicate;

      var empty = function empty(op) {
        return new _nodes.BinOp(variable, op, new _nodes.Empty());
      };

      var string = function string(op, val) {
        return (// eslint-disable-next-line no-new-wrappers
          new _nodes.BinOp(variable, op, new _nodes.String(val))
        );
      };

      var number = function number(op, val) {
        return (// eslint-disable-next-line no-new-wrappers
          new _nodes.BinOp(variable, op, new _nodes.Number(val))
        );
      };

      var choice = function choice(op) {
        return new _nodes.BinOp(variable, op, new Choice(variable.id, value));
      };

      var choiceList = function choiceList(op) {
        return new _nodes.BinOp(variable, op, new _nodes.List(value.map(function (i) {
          return new Choice(variable.id, i);
        })));
      };

      switch (predicate) {
        case _enums.PredicateOption.Response:
          return empty(_nodes.Op.IsNot);

        case _enums.PredicateOption.NoResponse:
          return empty(_nodes.Op.Is);

        case _enums.PredicateOption.Equals:
          {
            switch (type) {
              case _enums.VariableType.String:
                return string(_nodes.Op.Eq, value);

              case _enums.VariableType.Number:
                return number(_nodes.Op.Eq, value);

              case _enums.VariableType.Single:
                return choice(_nodes.Op.Eq);

              case _enums.VariableType.Multi:
                return choiceList(_nodes.Op.Eq);
            }

            break;
          }

        case _enums.PredicateOption.NotEquals:
          {
            switch (type) {
              case _enums.VariableType.String:
                return string(_nodes.Op.Ne, value);

              case _enums.VariableType.Number:
                return number(_nodes.Op.Ne, value);

              case _enums.VariableType.Single:
                return choice(_nodes.Op.Ne);

              case _enums.VariableType.Multi:
                return choiceList(_nodes.Op.Ne);
            }

            break;
          }

        case _enums.PredicateOption.Greater:
          return number(_nodes.Op.Gt, value);

        case _enums.PredicateOption.GreaterEqual:
          return number(_nodes.Op.Ge, value);

        case _enums.PredicateOption.Less:
          return number(_nodes.Op.Lt, value);

        case _enums.PredicateOption.LessEqual:
          return number(_nodes.Op.Le, value);

        case _enums.PredicateOption.StartsWith:
          if (type === _enums.VariableType.String) {
            return string(_nodes.Op.Ct, "^".concat(value));
          }

          break;

        case _enums.PredicateOption.EndsWith:
          if (type === _enums.VariableType.String) {
            return string(_nodes.Op.Ct, "".concat(value, "$"));
          }

          break;

        case _enums.PredicateOption.IsOneOf:
          if (type === _enums.VariableType.Single) {
            return choiceList(_nodes.Op.In);
          }

          break;

        case _enums.PredicateOption.IsNotOneOf:
          if (type === _enums.VariableType.Single) {
            return choiceList(_nodes.Op.NotIn);
          }

          break;

        case _enums.PredicateOption.Contains:
          switch (type) {
            case _enums.VariableType.String:
              return string(_nodes.Op.Ct, value);

            case _enums.VariableType.Multi:
              return choice(_nodes.Op.Eq);
          }

          break;

        case _enums.PredicateOption.NotContains:
          switch (type) {
            case _enums.VariableType.String:
              return string(_nodes.Op.NotCt, value);

            case _enums.VariableType.Multi:
              return choice(_nodes.Op.Ne);
          }

          break;

        case _enums.PredicateOption.ContainsAnyOf:
          switch (type) {
            case _enums.VariableType.Multi:
              return choiceList(_nodes.Op.In);
          }

          break;

        case _enums.PredicateOption.NotContainsAnyOf:
          switch (type) {
            case _enums.VariableType.Multi:
              return choiceList(_nodes.Op.NotIn);
          }

          break;

        case _enums.PredicateOption.ContainsAllOf:
          switch (type) {
            case _enums.VariableType.Multi:
              return choiceList(_nodes.Op.Ct);
          }

          break;

        case _enums.PredicateOption.NotContainsAllOf:
          switch (type) {
            case _enums.VariableType.Multi:
              return choiceList(_nodes.Op.NotCt);
          }

          break;
      }

      return node;
    }
  }]);

  return PredicateConverter;
}(_visitors.Transformer);
/**
 * This transformer attempts to convert expressions into predicate
 * expressions. It does this by pattern matching against certain predefined
 * predicate expression forms. The expression must already have its question
 * and choice references resolved to special nodes. This transformer is the
 * inverse of `PredicateConverter`. If the optional `lenient` parameter is
 * true, then the transformer will return `undefined` instead of throwing
 * an error when it fails to convert into a predicate expression.
 */


exports.PredicateConverter = PredicateConverter;

var PredicateSynthesizer = /*#__PURE__*/function (_Transformer5) {
  _inherits(PredicateSynthesizer, _Transformer5);

  var _super8 = _createSuper(PredicateSynthesizer);

  function PredicateSynthesizer(survey) {
    var _this9;

    var lenient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var allowNested = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, PredicateSynthesizer);

    _this9 = _super8.call(this);
    _this9.survey = survey;
    _this9.lenient = lenient;
    _this9.allowNested = allowNested;
    return _this9;
  }

  _createClass(PredicateSynthesizer, [{
    key: "fail",
    value: function fail(node) {
      if (this.lenient) {
        return undefined;
      }

      throw new Error('Could not convert to predicate expression');
    }
  }, {
    key: "visit_BoolOp",
    value: function visit_BoolOp(node) {
      var _this10 = this;

      var operands = [];
      node.operands.forEach(function (child) {
        // eslint-disable-next-line no-param-reassign
        var visitedChild = _this10.visit(child);

        if (!_this10.allowNested && visitedChild instanceof _nodes.BoolOp && visitedChild.op.name !== node.op.name) {
          _this10.fail();
        }

        if (visitedChild) {
          operands.push(visitedChild);
        }
      });

      if (operands.length === 0) {
        return undefined;
      }

      if (operands.length === 1) {
        return operands[0];
      }

      return new _nodes.BoolOp(node.op, operands);
    }
  }, {
    key: "visit_BinOp",
    value: function visit_BinOp(node) {
      var left = node.left;
      var variable;
      var type;

      if (left instanceof Question) {
        variable = left.getPredicateId();
        type = left.getVariableType(this.survey);
      } else if (left instanceof _nodes.Attribute && left.value instanceof _nodes.Identifier) {
        variable = left.toString();

        if (this.survey.getMeta != null && !this.survey.getMeta(variable)) {
          return this.fail();
        }

        type = _enums.VariableType.String;
      } else {
        return this.fail();
      }

      var inst = function inst(klass) {
        return function (obj) {
          return obj instanceof klass;
        };
      };

      var instChoiceList = function instChoiceList(obj) {
        if (!(obj instanceof _nodes.List)) {
          return false;
        }

        for (var i = 0; i < obj.items.length; i += 1) {
          var item = obj.items[i];

          if (!(item instanceof Choice)) {
            return false;
          }
        }

        return true;
      };

      var preds = [[_nodes.Op.Is, undefined, inst(_nodes.Empty), _enums.PredicateOption.NoResponse, undefined], [_nodes.Op.IsNot, undefined, inst(_nodes.Empty), _enums.PredicateOption.Response, undefined], [_nodes.Op.Eq, _enums.VariableType.String, inst(_nodes.String), _enums.PredicateOption.Equals, function (v) {
        return v.value;
      }], [_nodes.Op.Eq, _enums.VariableType.Single, inst(Choice), _enums.PredicateOption.Equals, function (v) {
        return v.id;
      }], [_nodes.Op.Eq, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.Equals, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.Eq, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.Equals, function (v) {
        return v.value;
      }], [_nodes.Op.Ne, _enums.VariableType.String, inst(_nodes.String), _enums.PredicateOption.NotEquals, function (v) {
        return v.value;
      }], [_nodes.Op.Ne, _enums.VariableType.Single, inst(Choice), _enums.PredicateOption.NotEquals, function (v) {
        return v.id;
      }], [_nodes.Op.Ne, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.NotEquals, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.Ne, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.NotEquals, function (v) {
        return v.value;
      }], [_nodes.Op.Ge, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.GreaterEqual, function (v) {
        return v.value;
      }], [_nodes.Op.Gt, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.Greater, function (v) {
        return v.value;
      }], [_nodes.Op.Le, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.LessEqual, function (v) {
        return v.value;
      }], [_nodes.Op.Lt, _enums.VariableType.Number, inst(_nodes.Number), _enums.PredicateOption.Less, function (v) {
        return v.value;
      }], [_nodes.Op.Ct, _enums.VariableType.String, function (v) {
        return v instanceof _nodes.String && /^\^/.test(v.value);
      }, _enums.PredicateOption.StartsWith, function (v) {
        return v.value.substring(1);
      }], [_nodes.Op.Ct, _enums.VariableType.String, function (v) {
        return v instanceof _nodes.String && /\$$/.test(v.value);
      }, _enums.PredicateOption.EndsWith, function (v) {
        return v.value.substring(0, v.value.length - 1);
      }], [_nodes.Op.In, _enums.VariableType.Single, instChoiceList, _enums.PredicateOption.IsOneOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.NotIn, _enums.VariableType.Single, instChoiceList, _enums.PredicateOption.IsNotOneOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.Ct, _enums.VariableType.String, inst(_nodes.String), _enums.PredicateOption.Contains, function (v) {
        return v.value;
      }], [_nodes.Op.NotCt, _enums.VariableType.String, inst(_nodes.String), _enums.PredicateOption.NotContains, function (v) {
        return v.value;
      }], [_nodes.Op.Eq, _enums.VariableType.Multi, inst(Choice), _enums.PredicateOption.Contains, function (v) {
        return v.id;
      }], [_nodes.Op.Ne, _enums.VariableType.Multi, inst(Choice), _enums.PredicateOption.NotContains, function (v) {
        return v.id;
      }], [_nodes.Op.In, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.ContainsAnyOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.NotIn, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.NotContainsAnyOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.Ct, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.ContainsAllOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }], [_nodes.Op.NotCt, _enums.VariableType.Multi, instChoiceList, _enums.PredicateOption.NotContainsAllOf, function (v) {
        return v.items.map(function (c) {
          return c.id;
        });
      }]];

      for (var i = 0; i < preds.length; i += 1) {
        var _preds$i = _slicedToArray(preds[i], 5),
            op = _preds$i[0],
            vartype = _preds$i[1],
            valpred = _preds$i[2],
            pred = _preds$i[3],
            valfunc = _preds$i[4];

        if (node.op !== op) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (vartype != null && type !== vartype) {
          // eslint-disable-next-line no-continue
          continue;
        }

        if (!valpred(node.right)) {
          // eslint-disable-next-line no-continue
          continue;
        }

        return new Predicate(variable, pred, typeof valfunc === 'function' ? valfunc(node.right) : undefined);
      }

      return this.fail();
    }
  }, {
    key: "visit_Node",
    value: function visit_Node() {
      return this.fail();
    }
  }]);

  return PredicateSynthesizer;
}(_visitors.Transformer);

exports.PredicateSynthesizer = PredicateSynthesizer;

var ReferencedQuestionsVisitor = /*#__PURE__*/function (_Visitor) {
  _inherits(ReferencedQuestionsVisitor, _Visitor);

  var _super9 = _createSuper(ReferencedQuestionsVisitor);

  function ReferencedQuestionsVisitor() {
    var _this11;

    var refs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ReferencedQuestionsVisitor);

    _this11 = _super9.call(this);
    _this11.refs = refs;
    return _this11;
  }

  _createClass(ReferencedQuestionsVisitor, [{
    key: "visit_Question",
    value: function visit_Question(node) {
      this.refs[node.id] = true;
    }
  }, {
    key: "visit_Predicate",
    value: function visit_Predicate(node) {
      var id = node.getQuestionId();

      if (id) {
        this.refs[id] = true;
      }
    }
  }]);

  return ReferencedQuestionsVisitor;
}(_visitors.Visitor);
/**
 * Ensures that all question and choice references in an expression are valid.
 * Call `isValid(node)` to check an expression.
 */


exports.ReferencedQuestionsVisitor = ReferencedQuestionsVisitor;

var ExpressionValidator = /*#__PURE__*/function (_Visitor2) {
  _inherits(ExpressionValidator, _Visitor2);

  var _super10 = _createSuper(ExpressionValidator);

  function ExpressionValidator(survey) {
    var _this12;

    _classCallCheck(this, ExpressionValidator);

    _this12 = _super10.call(this);
    _this12.survey = survey;
    return _this12;
  }

  _createClass(ExpressionValidator, [{
    key: "isValid",
    value: function isValid(node) {
      try {
        this.visit(node);
      } catch (error) {
        return false;
      }

      return true;
    }
  }, {
    key: "visit_Question",
    value: function visit_Question(node) {
      if (node.getQuestionInfo(this.survey) == null) {
        throw new Error('Invalid question');
      }
    }
  }, {
    key: "visit_Choice",
    value: function visit_Choice(node) {
      if (node.getChoiceInfo(this.survey) == null) {
        throw new Error('Invalid choice');
      }
    }
  }]);

  return ExpressionValidator;
}(_visitors.Visitor);

exports.ExpressionValidator = ExpressionValidator;